/* TWRD sticky notify bar for UPCOMING products (snippets/twrd-upcoming-buy.liquid).
   1. Moves the bar to <body>, so no transformed ancestor breaks position: fixed.
   2. The bar is always visible (Oliver 2026-10-21). It hides after a
      successful sign-up (card.is-done) and while the footer is on screen
      (Oliver 2026-10-22).
   3. "Notify me" scrolls to the sign-up box, opens the form and focuses the email field.
   While the bar shows, body gets twrd-notify-open and twrd-sticky-open, and
   --twrd-nbar-h holds the bar height. The CSS uses them for the page's bottom
   padding and to lift the chat bubble and back to top. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var bar = document.querySelector('[data-twrd-notify-bar]');
    if (!bar || bar.dataset.twrdBound) return;
    bar.dataset.twrdBound = '1';
    var card = document.querySelector('[data-twrd-up-card="' + bar.getAttribute('data-target') + '"]');
    var btn = bar.querySelector('[data-twrd-notify-go]');
    if (!card || !btn) return;

    document.body.appendChild(bar);
    bar.hidden = false;

    function measure() {
      document.documentElement.style.setProperty('--twrd-nbar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }

    var atFooter = false;

    function render() {
      var show = !card.classList.contains('is-done') && !atFooter;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      // Body padding stays at the footer, so the page height does not jump.
      var active = !card.classList.contains('is-done');
      document.body.classList.toggle('twrd-sticky-open', active);
      document.body.classList.toggle('twrd-notify-open', active);
      if (show) measure();
    }

    render();
    window.addEventListener('resize', measure);
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[0].isIntersecting;
        render();
      }).observe(footer);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(render).observe(card, { attributes: true, attributeFilter: ['class'] });
    }

    btn.addEventListener('click', function () {
      var details = card.querySelector('[data-twrd-up-notify]');
      var input = card.querySelector('input[type="email"]');
      card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      if (details && !details.open) details.open = true;
      if (input) input.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
